import './index.css';
const useAriaSnackbar = ({ role, 'aria-label': ariaLabel, hasAction }) => {
    let ariaAttributes = {
        role,
        'aria-label': ariaLabel,
    };
    if (hasAction || role === 'alertdialog') {
        ariaAttributes = {
            ...ariaAttributes,
            role: 'alertdialog',
            'aria-modal': 'true',
            tabIndex: 0,
        };
    }
    if (role !== 'status') {
        ariaAttributes = {
            ...ariaAttributes,
            'aria-describedby': 'dialog-description',
        };
    }
    return ariaAttributes;
};

export { useAriaSnackbar };
//# sourceMappingURL=useAriaSnackbar.js.map
